import { AuthPin } from './AuthPin.js'
import { ChangeTheme } from './ChangeTheme.js'
import { CultureSelector } from './CultureSelector.js'
import { Toaster } from './Toaster.js'
import { Wait } from './Wait.js'

export class BlazorHead {
	ChangeTheme: ChangeTheme
	CultureSelector: CultureSelector
	AuthPin: AuthPin
	Toaster: Toaster
	Wait: Wait
	constructor() {
		this.ChangeTheme = new ChangeTheme()
		this.CultureSelector = new CultureSelector()
		this.AuthPin = new AuthPin()
		this.Toaster = new Toaster()
		this.Wait = new Wait()
	}
}

(window as any).BlazorHead = new BlazorHead()
